import Container from '@mui/material/Container';
import { useSettingsContext } from 'src/components/settings';
import ModuleFeaturesMain from './featurecost-table';
// ----------------------------------------------------------------------

export default function ProductModuduleFeatures() {
  const settings = useSettingsContext();
  return (
    <Container maxWidth={ settings.themeStretch ? false : 'xl' }>
      <ModuleFeaturesMain />
    </Container>
  );
}
